import React, { useEffect } from 'react'
import { some } from 'lodash'

// accessors
import { useSelection } from 'flow/interactions/accessors'

// components
import Line from './Line'
import { SectionTitle, SectionTitleContainer } from 'components/Panel/common'
import { FormattedMessage } from 'react-intl'

const sortByLabel = (a, b) => {
  const labelA = a.data.label
  const labelB = b.data.label
  return labelA.localeCompare(labelB, undefined, {
    numeric: true,
    sensitivity: 'base'
  })
}

const sortByOrder = (a, b) => {
  return a.data.order - b.data.order
}

const stopPropagation = (e) => {
  e.stopPropagation()
}

const List = ({ currentNode, hasOrderData }) => {
  const [selection, setSelection] = useSelection()
  const isListConcepts = currentNode.data.nature === 'topic'

  useEffect(() => {
    return () => {
      // Reset when the node is changing
      setSelection([])
    }
  }, [currentNode.data.id, setSelection])

  return (
    <div onClick={stopPropagation}>
      {
        currentNode.children
          .sort(hasOrderData ? sortByOrder : sortByLabel)
          .map((d, i) => {
            return (
              <div key={d.data.id}>
                <Line
                  isCategoryLine={!isListConcepts}
                  key={d.data.id}
                  selection={selection}
                  setSelection={setSelection}
                  data={d.data}
                />
                {
                  (d.children || []).sort(sortByLabel).map((child) => {
                    return (
                      <Line
                        key={child.data.id}
                        selection={selection}
                        setSelection={setSelection}
                        data={child.data}
                      />
                    )
                  })
                }
              </div>
            )
          })
      }
    </div>
  )
}

const TreeList = ({ currentNode }) => {
  const nature = currentNode.data.nature
  const isUnit = nature === 'unit'
  const hasOrderData = isUnit && some(currentNode.children.map((d) => d.data.order))

  return (
    <>
      <SectionTitleContainer>
        <SectionTitle opacify>
          <FormattedMessage id={`list-title-${nature}-1`} />
          {
            hasOrderData && <FormattedMessage id='list-title-sorted' />
          }
        </SectionTitle>
        {
          hasOrderData && (
            <SectionTitle>
              <FormattedMessage id='list-title-sorted-type' />
            </SectionTitle>
          )
        }
      </SectionTitleContainer>
      <List
        currentNode={currentNode}
        hasOrderData={hasOrderData}
      />
    </>
  )
}

export default TreeList
